import "./index.css";
import "./i18n/config";

import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";

import App from "./App";
import store from "./redux/store";
import reportWebVitals from "./reportWebVitals";

// Appending Credimax SDKs scrips
const tapPaymentScript = document.createElement("script");
tapPaymentScript.src = `${process.env.REACT_APP_TAP_SDK_URL}`;
tapPaymentScript.async = true;
document.head.appendChild(tapPaymentScript);
const credimaxSessionScript = document.createElement("script");
credimaxSessionScript.src = `${process.env.REACT_APP_CREDIMAX_SESSION_SDK_URL}`;
credimaxSessionScript.async = true;
document.head.appendChild(credimaxSessionScript);

const threeDSScript = document.createElement("script");
threeDSScript.src = `${process.env.REACT_APP_CREDIMAX_THREEDS_SDK_URL}`;
threeDSScript.async = true;
document.head.appendChild(threeDSScript);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
  </Provider>,
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
